module.exports = __webpack_public_path__ + "static/media/landing.211f2bb0.svg";